import { ethers } from "ethers";
import { env } from "~/env";

export const getProvider = (rpcUrl?: string) => {
  return new ethers.JsonRpcProvider(rpcUrl ?? env.NEXT_PUBLIC_NETWORK_RPC_URL);
};
